import React, { useState } from "react";
import logo from "../assets/logo/logo.png";
import { Link } from "react-router-dom";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };



  return (
    <nav id="main-nav" className="fixed top-5 left-1/2 -translate-x-1/2 w-[90%] z-50 
            rounded-2xl border border-white/20 dark:border-gray-800
            bg-white/80 dark:bg-surface-dark/80 backdrop-blur-xl 
            shadow-soft transition-all duration-300 hover:shadow-hover">

      <div className="px-5 sm:px-8 h-16 flex items-center justify-between">

        <a className="flex items-center gap-3 text-gray-900 dark:text-white group shrink-0" href="/">
          <div className="size-9 rounded-[50%] bg-primary text-white flex items-center justify-center 
                    transform group-hover:rotate-[15deg] transition-all duration-300 shadow-glow">
            <img src={logo} alt="" />
          </div>
          <h2 className="text-lg font-display font-bold tracking-tight">
            Rahul<span className="text-primary">.Biswas</span>
          </h2>
        </a>

        <div className="hidden xl:flex items-center gap-1" n>
          <Link to="/#" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Home</Link>
          <Link to="/#about" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">About</Link>
          <Link to="/#skills" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Skills</Link>
          <Link to="/#education" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Education</Link>
          <Link to="/#experience" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Journey</Link>
          <Link to="/#projects" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Works</Link>
          <Link to="/#hobbies" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Hobbies</Link>
          <Link to="/#gallery" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Gallery</Link>
          <Link to="/blog" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Articles</Link>
          <Link to="/#reviews" className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-primary transition-colors">Reviews</Link>
        </div>


        <div className="flex items-center gap-3">
          <a className="hidden sm:flex bg-primary hover:bg-primary-dark text-white text-sm font-bold px-6 py-2.5 
                  rounded-xl transition-all transform hover:scale-105 active:scale-95 
                  shadow-lg shadow-primary/20 font-display" href="#contact">
            Contact
          </a>

          <button
            id="menu-toggle"
            onClick={toggleMenu}
            className="xl:hidden p-2 rounded-lg text-gray-600 dark:text-text-secondary transition-colors"
          >
            <span className="material-symbols-outlined" id="menu-icon">
              {isMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>
      </div>

      <div
        id="mobile-menu"
        className={`${isMenuOpen ? 'block' : 'hidden'} xl:hidden border-t border-gray-100 dark:border-gray-800 bg-white/95 dark:bg-surface-dark/95 backdrop-blur-xl rounded-b-2xl overflow-hidden`}
      >
        <div className="flex flex-col p-4 space-y-1 max-h-[70vh] overflow-y-auto">
          <a href="#" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Home</a>
          <a href="#about" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">About</a>
          <a href="#skills" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Skills</a>
          <a href="#projects" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Works</a>
          <a href="#experience" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Journey</a>
          <a href="#education" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Education</a>
          <a href="#hobbies" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Hobbies</a>
          <a href="#gallery" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Gallery</a>
          <a href="#articles" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Articles</a>
          <a href="#reviews" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl text-gray-600 dark:text-text-secondary hover:bg-primary/5 hover:text-primary">Reviews</a>
          <a href="#contact" onClick={() => setIsMenuOpen(false)} className="mobile-link block px-4 py-3 rounded-xl bg-primary text-white font-bold text-center mt-2">Contact</a>
        </div>
      </div>
    </nav>
  );
}

export default Header;